import React, { useState, useEffect } from "react";
import { Row, Col, Button, Input, Modal, Tooltip, Tabs, Table, Form, message } from "antd";
import { rol_captura } from "../../../utils/Console/roles";
import { inputs, txtTexto, nombres, txtNombres } from "../../../utils/Console/rules";
import { getGafetes, generateDocuments } from "../../../api/accreditation";
import useAuth from "../../../hooks/useAuth";
import { withRouter } from "react-router-dom";
import "./Console.scss";
import {
  createJobCruce,
  getListaJobs,
  createJobCruceFinalInf,
  getResumen,
  createJobCorteHomeWS,
  createJobNotificaCapacitacionJuntaWS,
} from "../../../api/cruces";

import TableJobs from "../../../components/Admin/Console/Table";

function Console(props) {
  const [reload, setReload] = useState(false);
  const [listaJobs, setListaJobs] = useState({
    list: [],
    loading: false,
  });
  const [rolModulo, setRolModulo] = useState({
    captura: false,
  });
  const {
    user: {user, rolUsuario, infoMenu },
  } = useAuth();
  
  const { proceso, setLoader } = props;
  const [form, formFinal] = Form.useForm();
  const [resumen, setResumen] = useState([]);
  const [refresh, setRefresh] = useState(false);
  
  let idProceso, idDetalle;
    //Se verica que este seleccionado un proceso electoral
    if(proceso.proceso) {
        idProceso = proceso.proceso.idProcesoElectoral;
        idDetalle = proceso.proceso.idDetalleProceso;
    }

  useEffect(() => {
    //Valida los permisos que tienen el usuario
    let captura = false;
    //Devuelve un true si cuenta con los permisos
    captura = rol_captura.includes(rolUsuario);
    setRolModulo(() => ({ captura })); //Se almacenan en el hook
    setListaJobs({ loading: true }); //Se habilita el componente de loading
    getListaJobs()
      .then((res) => {
        const dataSource = res.data;
        setListaJobs({ list: dataSource, loading: false }); //Se almacenan en el hook
      })
      .catch((error) => {
        console.log(error);
      });
    setReload(false);
    //La función useEffect se ejecutará cada vez que una de estas variables cambie su valor - U
  }, [reload, rolUsuario, infoMenu.listaDetalles]);

  useEffect(() => {
    getResumen()
      .then((res) => {
        setResumen(res.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }, [refresh]);

  //Función que crea una tarea de quartz
  const createJob = () => {
    //event.preventDefault();
    Modal.confirm({
      title: "Cruces de información",
      content: "¿Deseas programar esta tarea?",
      okText: "Crear",
      cancelText: "Cancelar",
      onOk() {
        sendJob(
          form.getFieldValue("nameJob"),
          form.getFieldValue("exprCron")
        );
      },
    });
  };

  function sendJob(nameJob, exprCron) {
    createJobCruce(nameJob, exprCron).then((res) => {
      if (res.data.code === 200) {
        Modal.success({
          content: res.data.message,
          okText: "Aceptar",
          onOk() {
            setReload(true); //Para volver a carga la tabla
          },
        });
      } else {
        Modal.error({
          content: res.data.message,
        });
      }
    });
  }

  const createJobCruceFinal = () => {
    Modal.confirm({
      title: "Cruces de información",
      content: "¿Deseas programar el cruce final de información?",
      okText: "Crear",
      cancelText: "Cancelar",
      onOk() {
        sendJobCruceFinal(
          formFinal.getFieldValue("nameJobFinal"),
          formFinal.getFieldValue("exprCronFinal")
        );
      },
    });
  };

  function sendJobCruceFinal(nameJob, exprCron) {
    createJobCruceFinalInf(nameJob, exprCron).then((res) => {
      if (res.data.code === 200) {
        Modal.success({
          content: res.data.message,
          okText: "Aceptar",
          onOk() {
            setReload(true); //Para volver a carga la tabla
          },
        });
      } else {
        Modal.error({
          content: res.data.message,
        });
      }
    });
  }

  const createJobCorteHome = () => {

    //console.log('En createJobCorteHome');

    //event.preventDefault();
    form.validateFields().then((values) => {

        console.log('En createJobCorteHome values', values);

        Modal.confirm({
          title: "Corte de información para el Home/Login",
          content: "¿Deseas programar el corte de información para el Home/Login?",
          okText: "Crear",
          cancelText: "Cancelar",
          onOk() {
            sendJobCorteHome(
              form.getFieldValue("nameJobCorteHome"),
              form.getFieldValue("exprCronCorteHome")
            );
          },
        });
      
    }).catch( (error) => {
      message.info("Los datos con ( * ) son requeridos.");
    });
  };

  function sendJobCorteHome(nameJob, exprCron) {

    createJobCorteHomeWS(nameJob, exprCron).then((res) => {

      console.log('createJobCorteHomeWS res-->',res);

      if (res.data.code === 200) {

        console.log('Exito 200::::',res.data.message);

        Modal.success({
          content: res.data.message,
          okText: "Aceptar",
          onOk() {
            setReload(true); //Para volver a carga la tabla
          },
        });

      } else {
        console.log('Else res.data.message::::',res.data.message);
        Modal.error({
          content: res.data.message,
        });
      }
    }).catch( (err) => {
      Modal.error({
        content: 'Ocurrio un error Generación de corte de información ',
      });
    });

  }

  const createJobNotificaCapacitacion = (event) => {
    event.preventDefault();
    Modal.confirm({
      title: "Notificación sobre el proceso de capacitación",
      content: "¿Deseas programar la notificación de las juntas ejecutivas sobre el proceso de capacitación?",
      okText: "Crear",
      cancelText: "Cancelar",
      onOk() {
        sendJobNotificaCapacitacionJunta(
          form.getFieldValue("nameJobNotificaCapacitacionJunta"),
          form.getFieldValue("exprCronNotificaCapacitacionJunta")
        );
      },
    });
  };

  function sendJobNotificaCapacitacionJunta(nameJob, exprCron) {
    createJobNotificaCapacitacionJuntaWS(nameJob, exprCron).then((res) => {
      if (res.data.code === 200) {
        Modal.success({
          content: res.data.message,
          okText: "Aceptar",
          onOk() {
            setReload(true); //Para volver a carga la tabla
          },
        });
      } else {
        Modal.error({
          content: res.data.message,
        });
      }
    });
  }

  function handleUpdateGafetes () {
    setLoader({ loading: true, message: "Actualizando..." })
    const tipoDocumento = 1; //0 = Constancia, 1 = Gafete, 2 = ambos
    const tipoFirma = 0; // 0= con firma , 1 = sin firma
    getGafetes(idProceso, idDetalle, tipoDocumento ).then(res=>{
      if (res.data.code === 200){
        const solicitud = {
          idDetalleProceso    : idDetalle,
          idProcesoElectoral  : idProceso,
          idDistritoFederal   : 0,
          idEstadoDistrito    : 0,
          listaAcreditados    : res.data.solicitudesAcreditadas,
          tipoDocumento       : tipoDocumento, //0 = Constancia, 1 = Gafete, 2 = ambos
          tipoFirma           : tipoFirma, // 0= con firma , 1 = sin firma
          totalAcreditadas    : res.data.lenght,
          usuario             : user.sub,
        }
        generateDocuments(solicitud).then(res =>{
          setLoader({ loading: false, message: "" }); //Se desactiva el loader
          if (res.status === 200) {
            //Si se necesita ver todos los documentos generados se deben descomentar estas lineas
            /*var urlCreator = window.URL || window.webkitURL || window.mozURL || window.msURL;
            const url = urlCreator.createObjectURL(new Blob([res.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', `DocumentosAcreditacion.zip`);
            document.body.appendChild(link);
            link.click();
            link.parentNode.removeChild(link);*/
            Modal.success({
              content: "Los gafetes se actualizaron correctamente",
              okText: "Aceptar",
            });
          } else {
            Modal.error({
              content: "Ocurrió un error al actualizar los gafetes",
            });
          }
        })
      }else{
        setLoader({ loading: false, message: "" })
        Modal.warning({
          content: res.data.causa,
        });
      }  
    })
  }

  const dataResumen = [
    {
      key: "1",
      descripcion: "Total de solicitudes:",
      valor: resumen.totalSolicitudes,
    },
    {
      key: "2",
      descripcion: "Registros nuevos por cruzar:",
      valor: resumen.nuevos,
    },
    {
      key: "3",
      descripcion: "Registros cruzando:",
      valor: resumen.procesando,
    },
    {
      key: "4",
      descripcion: "Registros cruzados (cruce inicial):",
      valor: resumen.cruceIni,
    },
    {
      key: "5",
      descripcion: "Registros cruzados (cruce final):",
      valor: resumen.cruceFinal,
    },
    {
      key: "6",
      descripcion: "Total de claves de elector en cargas:",
      valor: resumen.totalCargas,
    },
    {
      key: "7",
      descripcion: "Claves de elector de Candidatos:",
      valor: resumen.candidatos,
    },
    {
      key: "8",
      descripcion: "Claves de elector de Representantes:",
      valor: resumen.representantes,
    },
    {
      key: "9",
      descripcion: "Claves de elector de Funcionarios:",
      valor: resumen.funcionarios,
    },
  ];

  const columnsResumen = [
    {
      title: "Resumen de cruces",
      colSpan: 2,
      dataIndex: "descripcion",
    },
    {
      title: "",
      colSpan: 0,
      dataIndex: "valor",
      render: (record) => (
        <><b>{record}</b></>
      ),
    },
  ];

  return (
    <div>
      <Row>
        <Col span={24}>
          <h1>Consola de operaci&oacute;n</h1>
        </Col>
      </Row>
      <Tabs defaultActiveKey="1" className="tabsConsola tabsBottomLineConsola">
        <Tabs.TabPane tab="Resumen de cruces" key="1">
          <div>
            <Row>
              <Col span={16}>
                <Table dataSource={dataResumen} columns={columnsResumen} pagination={false} />
              </Col>
              <Col span={8} className="centroCol">
                <Button type="primary" className="buttonTextAjustado"
                  onClick={(e) => {
                    if (refresh) {
                      setRefresh(false);
                    } else {
                      setRefresh(true);
                    }
                  }}
                >
                  Actualizar resumen
                </Button>
              </Col>
            </Row>
          </div>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Cruces de información con otros sistemas" key="2">
          <div>
            <Row>
              <Col span={24} className="colorBack">
                <p className="colorTextWhite">Cruces iniciales de información (Candidatos)</p>
              </Col>
            </Row>
            {rolModulo.captura && (
              <>
                <Form form={form} onFinish={createJob} layout="vertical">
                  <Row gutter={20}>
                    <Col span={8} className="marginLeft16">
                      <Tooltip title="Ejemplo: cruceInicial">
                        <Form.Item
                          name="nameJob"
                          label={<div>Nombre del job</div>}
                          rules={ nombres }
                          getValueFromEvent={ (event) => {
                            return txtNombres.test(event.target.value)
                              ? event.target.value
                              : (event.target.value).slice(0,-1);
                          }}
                        >
                              <Input placeholder="Nombre del job" required={true} />
                        </Form.Item>
                      </Tooltip>
                    </Col>
                    <Col span={5}>
                      <Tooltip title="Cada 5 minutos: 0 0/5 * * * ?">
                        <Form.Item
                          name="exprCron"
                          label={<div>Expresi&oacute;n cron</div>}
                          rules={ inputs }
                          getValueFromEvent={ (event) => {
                            return txtTexto.test(event.target.value)
                              ? event.target.value
                              : (event.target.value).slice(0,-1);
                          }}
                        >                          
                            <Input placeholder="Expresi&oacute;n Cron" required={true} />
                        </Form.Item>
                      </Tooltip>
                    </Col>
                    <Col span={3}>
                      <Form.Item>
                        <Button type="primary" htmlType="submit"
                          className="row25px"
                        >
                          Programar cruces
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </>
            )}
            <Row>
              <Col span={24} className="colorBack">
                <p className="colorTextWhite">Cruce final de información (Candidatos, Representantes y Funcionarios)</p>
              </Col>
            </Row>
            {rolModulo.captura && (
              <>
                <Form form={formFinal} onFinish={createJobCruceFinal} layout="vertical">
                  <Row gutter={20}>
                    <Col span={8} className="marginLeft16">
                      <Tooltip title="Ejemplo: cruceFinal">
                        <Form.Item
                          name="nameJobFinal"
                          label={<div>Nombre del job</div>}
                          rules={ nombres }
                          getValueFromEvent={ (event) => {
                            return txtNombres.test(event.target.value)
                              ? event.target.value
                              : (event.target.value).slice(0,-1);
                          }}
                        >
                            <Input placeholder="Nombre del job" required={true} />
                        </Form.Item>
                      </Tooltip>
                    </Col>
                    <Col span={5}>
                      <Tooltip title="Expresi&oacute;n para una sola ejecución">
                        <Form.Item
                          name="exprCronFinal"
                          label={<div>Expresi&oacute;n cron</div>}
                          rules={ inputs }
                          getValueFromEvent={ (event) => {
                            return txtTexto.test(event.target.value)
                              ? event.target.value
                              : (event.target.value).slice(0,-1);
                          }}
                        >
                              <Input placeholder="Expresi&oacute;n Cron" required={true} />
                        </Form.Item>
                      </Tooltip>
                    </Col>
                    <Col span={3}>
                      <Form.Item>
                        <Button type="primary" htmlType="submit"
                          className="row25pxwidth200"
                        >
                          Programar cruce final
                        </Button>
                      </Form.Item>
                    </Col>
                  </Row>
                </Form>
              </>
            )}
          </div>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Generación del mapa interactivo" key="3">
          <div>
            <Row>
              <Col span={24} className="colorBack">
                <p className="colorTextWhite">Generación de corte de información para el mapa interactivo del Login/Home</p>
              </Col>
            </Row><br />
            {rolModulo.captura && (
              <>                
                <Form form={form}>
                    <Row gutter={24} >
                      <Col span={5} className="marginLeft16">
                        <Tooltip title="Ejemplo: corteHomeLogin">
                          <Form.Item
                            name="nameJobCorteHome"
                            label={<div>Nombre del job</div>}
                            rules={ nombres }
                            getValueFromEvent={ (event) => {
                              return txtNombres.test(event.target.value)
                                ? event.target.value
                                : (event.target.value).slice(0,-1);
                            }}
                          >
                                <Input placeholder="Nombre del job" required={true} />
                          </Form.Item>
                        </Tooltip>
                      </Col>
                      <Col span={5}>
                        <Tooltip title="Cada 10 minutos: 0 0/10 * * * ?">
                          <Form.Item
                            name="exprCronCorteHome"
                            label={<div>Expresi&oacute;n cron</div>}
                            rules={ inputs }
                            getValueFromEvent={ (event) => {
                              return txtTexto.test(event.target.value)
                                ? event.target.value
                                : (event.target.value).slice(0,-1);
                            }}
                          >
                                <Input placeholder="Expresi&oacute;n Cron" required={true} />
                          </Form.Item>
                        </Tooltip>
                      </Col>
                      <Col span={5}>
                        <Form.Item>
                          <Button type="primary" htmlType="submit" 
                                  className="row25pxwidth200"
                                  onClick={createJobCorteHome} >

                            Programar corte
                          </Button>
                        </Form.Item>
                      </Col>
                    </Row>
                </Form>

              </>
            )}
          </div>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Notificación para las Juntas" key="4">
          <div>
            <Row>
              <Col span={24} className="colorBack">
                <p className="colorTextWhite">Notificación para las juntas ejecutivas sobre el proceso de capacitación</p>
              </Col>
            </Row>
            {rolModulo.captura && (
              <>
                <Form onSubmit={createJobNotificaCapacitacion}>
                    <Row gutter={20}>
                      <Col span={5} className="marginLeft16">
                        <Form.Item
                          name="nameJobNotificaCapacitacionJunta"
                          label={<div>Nombre del job</div>}
                          rules={ nombres }
                          getValueFromEvent={ (event) => {
                            return txtNombres.test(event.target.value)
                              ? event.target.value
                              : (event.target.value).slice(0,-1);
                          }}
                        >
                          <Tooltip title="Ejemplo: notificaCapacitacionJunta">
                              <Input placeholder="Nombre del job" required={true} />
                          </Tooltip>
                        </Form.Item>
                      </Col>
                      <Col span={5}>
                        <Form.Item
                          name="exprCronNotificaCapacitacionJunta"
                          label={<div>Expresi&oacute;n cron</div>}
                          rules={ inputs}
                          getValueFromEvent={ (event) => {
                            return txtTexto.test(event.target.value)
                              ? event.target.value
                              : (event.target.value).slice(0,-1);
                          }}
                        >
                          <Tooltip title="Expresión para cada 24 horas">
                              <Input placeholder="Expresi&oacute;n Cron" required={true} />
                          </Tooltip>
                        </Form.Item>
                      </Col>
                      <Col span={3}>
                        <Form.Item>
                          <Button type="primary" htmlType="submit"
                            className="row25pxwidth200"
                          >
                            Programar notificación 
                          </Button>
                        </Form.Item>
                      </Col>
                    </Row>
                </Form>
              </>
            )}
          </div>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Lista de tareas actuales" key="5">
          <div>
            <Row>
              <Col span={24} className="colorBack">
                <p className="colorTextWhite">Lista de tareas actuales</p>
              </Col>
            </Row>
            <Row>
              <TableJobs data={listaJobs.list}
                setReload={setReload}
                loading={listaJobs.loading}
              />
            </Row>
          </div>
        </Tabs.TabPane>
        <Tabs.TabPane tab="Actualización de gafetes" key="6">
          <>
            <Row>
              <Col span={16} className="colorBack">
                <p className="colorTextWhite">Actualización de gafetes</p>
              </Col>
            </Row>
                <Col span={16} style={{ textAlign: "center", margin: "10px" }}>
                    <Button 
                        type="primary"
                        onClick={()=>handleUpdateGafetes()}>
                        Actualizar
                    </Button>
                </Col>
          </>
        </Tabs.TabPane>
      </Tabs>
    </div>
  );
}

export default withRouter(Console);
